import { createAction } from 'redux-actions'

import * as constants from './constants'

export const createNewsletterPlaybook = createAction(constants.CREATE_NEWSLETTER_PLAYBOOK)
export const createNewsletterPlaybookSuccess = createAction(constants.CREATE_NEWSLETTER_PLAYBOOK_SUCCESS)
export const createNewsletterPlaybookPending = createAction(constants.CREATE_NEWSLETTER_PLAYBOOK_PENDING)
export const createNewsletterPlaybookFailed = createAction(constants.CREATE_NEWSLETTER_PLAYBOOK_FAILED)

export const createDemoRequestPlaybook = createAction(constants.CREATE_DEMO_REQUEST_PLAYBOOK)
export const createDemoRequestPlaybookSuccess = createAction(constants.CREATE_DEMO_REQUEST_PLAYBOOK_SUCCESS)
export const createDemoRequestPlaybookPending = createAction(constants.CREATE_DEMO_REQUEST_PLAYBOOK_PENDING)
export const createDemoRequestPlaybookFailed = createAction(constants.CREATE_DEMO_REQUEST_PLAYBOOK_FAILED)

export const updateCLPSettings = createAction(constants.UPDATE_CLP_SETTINGS)
export const updateCLPSettingsSuccess = createAction(constants.UPDATE_CLP_SETTINGS_SUCCESS)
export const updateCLPSettingsPending = createAction(constants.UPDATE_CLP_SETTINGS_PENDING)
export const updateCLPSettingsFailed = createAction(constants.UPDATE_CLP_SETTINGS_FAILED)

export const fetchCLPSettings = createAction(constants.FETCH_CLP_SETTINGS)
export const fetchCLPSettingsSuccess = createAction(constants.FETCH_CLP_SETTINGS_SUCCESS)
export const fetchCLPSettingsPending = createAction(constants.FETCH_CLP_SETTINGS_PENDING)
export const fetchCLPSettingsFailed = createAction(constants.FETCH_CLP_SETTINGS_FAILED)

export const fetchCLPSubdomain = createAction(constants.FETCH_CLP_SUBDOMAIN)
export const fetchCLPSubdomainSuccess = createAction(constants.FETCH_CLP_SUBDOMAIN_SUCCESS)
export const fetchCLPSubdomainPending = createAction(constants.FETCH_CLP_SUBDOMAIN_PENDING)
export const fetchCLPSubdomainFailed = createAction(constants.FETCH_CLP_SUBDOMAIN_FAILED)

export const setCLPSubdomain = createAction(constants.SET_CLP_SUBDOMAIN)

export const fetchCLPCname = createAction(constants.FETCH_CLP_CNAME)
export const fetchCLPCnameSuccess = createAction(constants.FETCH_CLP_CNAME_SUCCESS)
export const fetchCLPCnamePending = createAction(constants.FETCH_CLP_CNAME_PENDING)
export const fetchCLPCnameFailed = createAction(constants.FETCH_CLP_CNAME_FAILED)

export const createWelcomePlaybooks = createAction(constants.CREATE_WELCOME_PLAYBOOKS)
export const createWelcomePlaybooksSuccess = createAction(constants.CREATE_WELCOME_PLAYBOOKS_SUCCESS)
export const createWelcomePlaybooksPending = createAction(constants.CREATE_WELCOME_PLAYBOOKS_PENDING)
export const createWelcomePlaybooksFailed = createAction(constants.CREATE_WELCOME_PLAYBOOKS_FAILED)

export const setPlaybookType = createAction(constants.SET_PLAYBOOK_TYPE)

// Demo Request Playbook Props
export const setProductName = createAction(constants.SET_PRODUCT_NAME)
export const setValueProp = createAction(constants.SET_VALUE_PROP)
export const setIndustry = createAction(constants.SET_INDUSTRY)


export const setWidgetVerified = createAction(constants.SET_WIDGET_VERIFIED)





// WEBPACK FOOTER //
// ./src/modules/playbook/actions.js